export default __webpack_public_path__ + "static/media/Anuphan-SemiBold.8ed71a02.woff";